import { FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import appState from '../../state/AppStateContainer';
import { dismissUpdatesAnnouncement, getUpdatesAnnouncement } from '../../state/updatesStatus';
import BtWelcomeModal from '../bt-welcome-modal/bt-welcome-modal';
import { formatSentAt } from '../page-updates/NewsletterRail';

const AppUpdatesNotice: FC = () => {
  const [t, i18n] = useTranslation('updates');
  const history = useHistory();
  const { pathname } = useLocation();
  const orgSlug = appState.getCurrentOrgSlug();

  const announcement = getUpdatesAnnouncement();
  const isInsideOrg = !!orgSlug && pathname.startsWith(`/${orgSlug}/`);
  const isOnUpdates = pathname.startsWith(`/${orgSlug}/updates`);
  if (!announcement || !isInsideOrg || isOnUpdates || !appState.getUserId()) return null;

  const readMore = () => {
    dismissUpdatesAnnouncement();
    history.push(`/${orgSlug}/updates?tab=${announcement.audience}&id=${announcement.id}`);
  };

  return (
    <BtWelcomeModal
      chip={t('notice.chip', 'Nyhet')}
      meta={formatSentAt(announcement.sentAt, i18n.language)}
      title={announcement.title}
      lead={announcement.summary ?? undefined}
      visual={<NewsletterIllustration />}
      cta={{ label: t('notice.readMore', 'Läs mer'), onClick: readMore }}
      closeLabel={t('notice.close', 'Stäng')}
      onDismiss={dismissUpdatesAnnouncement}
    />
  );
};

const NewsletterIllustration: FC = () => (
  <svg viewBox="0 0 440 160" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="60" y="12" width="320" height="148" rx="8" fill="white" opacity="0.92"/>
    <rect x="60" y="12" width="320" height="34" rx="8" fill="#6366F1" opacity="0.85"/>
    <rect x="60" y="38" width="320" height="8" fill="#6366F1" opacity="0.85"/>
    <rect x="80" y="24" width="90" height="10" rx="5" fill="white" opacity="0.9"/>
    <rect x="80" y="62" width="180" height="10" rx="5" fill="#374151"/>
    <rect x="80" y="82" width="280" height="6" rx="3" fill="#9CA3AF"/>
    <rect x="80" y="96" width="250" height="6" rx="3" fill="#9CA3AF"/>
    <rect x="80" y="110" width="265" height="6" rx="3" fill="#D1D5DB"/>
    <rect x="80" y="130" width="72" height="20" rx="10" fill="#DCFCE7"/>
    <rect x="92" y="137" width="48" height="6" rx="3" fill="#16A34A"/>
  </svg>
);

export default AppUpdatesNotice;
